import { css } from '@emotion/react';
import { PropsWithChildren } from 'react';

import { theme } from './theme';

const styles = {
  itemContainer: css`
    background-color: ${theme.colors.gray[0]};
    padding: ${theme.spacing.md};
    border-radius: ${theme.borders.radius.md};
    width: 100%;
  `,
  card: css`
    padding: ${theme.spacing.md};
    background-color: ${theme.colors.white};
    border-radius: ${theme.borders.radius.md};
  `,
  marginOverride: css`
    margin-bottom: ${theme.spacing.sm};
    font-size: ${theme.fontSize.sm};
  `,
};

export function LegacyCard({ children, className, title }: PropsWithChildren<{ className?: string; title?: string }>) {
  return (
    <div className={className} css={styles.card}>
      {title && <h3>{title}</h3>}
      {children}
    </div>
  );
}

export const CardSecondary = ({
  title,
  className,
  children,
}: PropsWithChildren<{ title?: string; className?: string }>) => {
  return (
    <div css={styles.itemContainer} className={className}>
      {title && (
        <p css={styles.marginOverride}>
          <b>{title}</b>
        </p>
      )}
      {children}
    </div>
  );
};
